/**
 * WhatsApp Cloud API image constraints used by Template IMAGE headers and
 * Business Profile pictures.
 *
 * Sources (Meta Developer Tools MCP, 2026-09-10):
 * - Template media / components: IMAGE header sample uses Resumable Upload API
 *   (`header_handle`). Send-time media uses Cloud API media `id` (recommended)
 *   or `link`.
 * - Resumable Upload API file types: `image/jpeg`, `image/jpg`, `image/png`
 *   (also pdf/mp4, which are not used here).
 * - WhatsApp Cloud API outbound IMAGE messages: 5MB, `image/jpeg` + `image/png`
 *   (same cap already encoded in outbound-media-capabilities).
 * - Business Profile docs specify `profile_picture_handle` from Resumable Upload
 *   and do not publish a distinct byte/dimension limit in the current Graph docs.
 *   Live Meta rejections require at least 192×192 pixels. Square is not required.
 * - MIME/byte limits reuse the documented Cloud API IMAGE cap and Resumable
 *   Upload image MIME types.
 */
export const WHATSAPP_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
/** Minimum pixel size Meta accepts for WhatsApp Business Profile pictures. */
export const WHATSAPP_PROFILE_PICTURE_MIN_PX = 192;
export function isWhatsAppProfilePictureLargeEnough(width, height) {
    return width >= WHATSAPP_PROFILE_PICTURE_MIN_PX && height >= WHATSAPP_PROFILE_PICTURE_MIN_PX;
}
export const WHATSAPP_IMAGE_MIME_TYPES = ["image/jpeg", "image/png"];
const ALLOWED = new Set(WHATSAPP_IMAGE_MIME_TYPES);
/** `image/jpg` is listed by Resumable Upload; treat as JPEG. */
export function normalizeWhatsAppImageMime(mimeType) {
    const normalized = mimeType.trim().toLowerCase().split(";")[0]?.trim() ?? "";
    if (normalized === "image/jpg" || normalized === "image/jpeg") {
        return "image/jpeg";
    }
    if (ALLOWED.has(normalized)) {
        return normalized;
    }
    return null;
}
export function isWhatsAppImageMimeAllowed(mimeType) {
    return normalizeWhatsAppImageMime(mimeType) !== null;
}
//# sourceMappingURL=whatsapp-image-limits.js.map